<template lang="html">
<div class="pgInner quEdit">

    <div class="headBar">
        <span v-if="params.id">编辑问题</span>
        <span v-else>新建问题</span>
    </div>

    <div class="pgbody" :style="'height:' + pageH + 'px;'">
         <el-scrollbar ref="scroller" style="height:100%;">

           <el-form ref="ruleForm" :model="params" :rules="rules" inline-message="true" :show-message="false">

               <div class="tabContent">

                 <div class="text-block clearfix">
                     <div class="bName">问题</div>
                     <div class="bContent">
                           <el-input size="medium" class="inpText" v-model="params.question" placeholder="请输入问题内容"></el-input>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">回答</div>
                     <div class="bContent">
                         <!-- <textEditor ref="textEditor" :inContent="params.answer" /> -->
                         <el-input type="textarea" rows="5" size="medium" v-model="params.answer" placeholder="请输入问题内容"></el-input>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">关联内容</div>
                     <div class="bContent">
                           <el-select
                             class="inpText"
                             v-model="selectId"
                             filterable
                             remote
                             placeholder="请输入关键词"
                             size="medium"
                             @change="selectChange"
                             :remote-method="affSeek"
                             :loading="loading">
                             <el-option
                               v-for="item in selectArr"
                               :key="item.id"
                               :label="item.title"
                               :value="item.id">
                             </el-option>
                           </el-select>
                           <el-button @click="affAdd" size="medium" style="width:80px;margin-left:12px;" type="primary">添加</el-button>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName"></div>
                     <div class="bContent">
                         <table v-if="tabArr.length > 0" class="pocTab">
                              <tr>
                                  <td class="tSpan1">标题</td><td class="tSpan2">操作</td>
                              </tr>
                              <tr v-for="(item,index) in tabArr">
                                  <td class="tSpan1">{{ item.description }}</td><td class="tSpan2">
                                      <span @click="goRemove(index)" class="ibtn">删除</span>
                                  </td>
                              </tr>
                         </table>
                     </div>
                 </div>

               </div>

            </el-form>

         </el-scrollbar>
    </div>

    <div class="pagefoot">

      <div v-if="pgState" class="loading">
           <span v-if="pgState == 3">初始化中...</span>
           <span v-if="pgState == 4">数据保存中...</span>
           <i class="el-icon-loading"></i>
      </div>
      <div v-else>
           <el-button @click="directSave(1)" type="primary" size="small">保存并发布</el-button>
           <el-button @click="goReturn" plain size="small">取消</el-button>
      </div>

    </div>

</div>
</template>

<script>
import Editor from "@/components/KindEditor/KindEditor";
import { quCreate,quRelateSave,quItem,quRelate } from "@/api/message/message";
import { dicSeek } from "@/api/pgMent/dictMent";
import { affList } from "@/api/affairs/affairs";
export default {
    components:{
        Editor
    },
    computed:{
      pgState:function(){
          var state = 0;
          if(this.params.id && !this.readyKey){
              state = 1;
          }

          if(this.uploadIng){
              state = 2;
          }

          return state;
      }
    },
    data(){
        return{

            pageH:'',
            selectArr:[],
            selectMap:{},
            uploadIng:false,
            selectId:'',

            readyKey:false,

            tabArr:[],
            tempStore:'',

            ansStore:'',

            params:{
                id:'',
                question:'',
                answer:'',
                sort:'',
                status:1
            },

            rules:{

            }

        }
    },

    methods:{

        goReturn:function(){
            this.$router.go(-1);
        },

        pageFix:function(){
            this.pageH = document.documentElement.clientHeight - 205;
        },

        contentChange:function(e){    // 富文本内容
            this.params.content = e;
        },

        affSeek:function(e){
            var vues = this;
            var key = e.replace(/\s+/g,'');
            if(key){
              affList({
                  keyword:key,
                  status:1,
                  sort:2,
                  no:1,
                  size:20
              }).then(res => {
                 vues.selectArr = res.handleMattersList;
                 res.handleMattersList.forEach(item => {
                     vues.selectMap[item.id] = item;
                 })
              })
            }
        },

        affAdd:function(){
            let inTab = true;

            this.tabArr.forEach(item => {
                if(item.id == this.tempStore.id){
                    inTab = false;
                    return;
                }
            })

            if(inTab){
                this.tabArr.push(this.relateCreate(this.tempStore));
            }else{
                this.$message.error('已加入列表！');
            }

        },

        goRemove:function(inx){
            this.tabArr.splice(inx,1);
        },

        selectChange:function(e){
           this.tempStore = this.selectMap[e];
        },

        goCreate:function(){  // 创建
            var vues = this;
            this.uploadIng = true;
            msgCreate({businessNews:this.params}).then(res => {
                vues.$router.push('atv_message');
            }).catch(err => {})
        },

        relateCreate:function(item){
          var tempItem = {
              id:'',
              problemId:'',
              businessId:item.id,
              description:item.title,
              type:2,
              question:this.params.question,
              answer:this.params.answer,
              status:1
          };

          return tempItem;
        },

        directSave:function(status){
            var vues = this;
            // console.log(this.params.answer.replace(/\r|\n/,','));
            if(!this.params.question){
                 this.$message.error('问题必须填写！');
            }else if(!this.params.answer){
                 this.$message.error('回答必须填写！');
            }else{
                 vues.params.status = status;
                 // this.params.answer.replace(/\r|\n/,',');
                 quCreate({commonProblem:vues.params}).then(res => {
                     var arrs = [];
                     if(vues.tabArr.length > 0){
                         vues.tabArr.forEach(item => {
                              if(!item.problemId){
                                  item.problemId = res.commonProblem.id;
                              };
                              arrs.push(item);
                         });
                        quRelateSave({commonRelatedProblemList:arrs}).then(res => {
                            vues.$router.push('ques_list');
                        }).catch(err => {
                            vues.$message.error('保存错误！');
                        })
                     }else{
                         vues.$router.push('ques_list');
                     }

                     

                 })
            }
        },

        imgChange:function(e){
            this.params.coverImage = e;
        },

        prevSet:function(){

            var vues = this;
            var querys = this.$route.query;

            // 底部定位
            this.pageFix();

            if(querys && querys.id){
                this.params.id = querys.id;
                quItem({id:querys.id}).then(res => {
                    vues.params = res.commonProblem;
                    quRelate({
                         problemId:querys.id,
                         no:1,
                         size:20
                    }).then(inres => {
                         vues.tabArr = inres.commonRelatedProblemList;
                         vues.readyKey = true;
                    })
                    // vues.eprSeek(vues.params.publishCompany);
                })
            }else{
                this.preCode = JSON.stringify(this.params);
                // this.tmSave();
            }

        },
    },
    created:function(){
        var vues = this;

        $(window).on('resize',function(){
    		     vues.pageFix();
             vues.$refs.scroller.$data.sizeHeight = this.pageH;
    	  })

        this.prevSet();

    },

    beforeDestroy:function(){
        $(window).off('resize');
        // clearInterval(this.waitSave);
    }


}
</script>

<style lang="scss" scoped>

.pgInner{
  background: #f5f5f5;
}

.headBar{
  height: 55px;
  line-height: 55px;
  font-size: 16px;
  padding-left: 20px;
  background: white;
}

.pgbody{
  margin: 20px;
}

.tabNavs{
  height: 50px;
  padding-left: 15px;
  background: white;
  position: relative;
  .tabItem{
     float: left;
     height: 50px;
     line-height: 50px;
     font-size: 15px;
     margin-right: 45px;
     cursor: pointer;
  }
  .tabItem.act{
    color: rgb(86, 119, 252);
  }
  .moveLine{
    height: 2px;
    background: rgb(86, 119, 252);
    position: absolute;
    bottom: 0px;

    transition-property: all;
    transition-duration: 0.2s;
  }
}

.tabContent{
  padding: 20px;
  background: white;
}

.pagefoot{
  height: 60px;
  line-height: 60px;
  background: white;
  padding-left: 20px;
  position: relative;
  z-index: 2;
  .btn{
    height: 32px;
    padding: 0 12px;
    margin-right: 12px;
    display: inline-block;
    font-size: 14px;
    cursor: pointer;
  }
  .type1{
    line-height: 32px;
    background: rgb(86, 119, 252);
    color: white;
  }
  .type2{
    box-sizing: border-box;
    border: 1px solid #aeaeae;
    line-height: 30px;
  }

  .loading{
     font-size: 14px;
     padding-left: 24px;
     color: #AEAEAE;
     i{
         font-size: 18px;
         vertical-align: middle;
     }
  }
}

.text-block{
      font-size: 14px;
     .bName{
          width: 60px;
          padding-top: 8px;
          float: left
     }
     .bContent{
          margin-left: 70px;
          position: relative;
          margin-bottom: 20px;

          .inpText{
               width: 420px;
          }
     }
}

.radio-block .el-radio-group{
     margin-top: 12px;
}

.pocTab{
     width: 100%;
     border-collapse: collapse;
}

.pocTab td{
    border: 1px solid #ebeef5;
    padding: 8px 20px;
}

.pocTab .tSpan2{
    width: 120px;
    text-align: center;
}

.pocTab .ibtn{
   font-size: 14px;
   cursor: pointer;
   color: #409EFF;
}

</style>

<style lang="css">

.quEdit .el-input__inner{
    border-radius: 0px;
}

</style>



// WEBPACK FOOTER //
// quEdit.vue?4836ba7a